import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

//axios请求
import axios from "./axios/axios";
import api from "./axios/api";

//js bridge
import bridge from "@/utils/bridge.js";

//公共方法
import { numberHandle, mathJs } from "@/utils/index.js";
import "@/utils/updatedVersion.js";

//rem适配
import remSize from "./utils/remSize.js";
remSize();

//国际化
import i18n from "./utils/i18n/index";

//ui类库、公共组件
import "./utils/Ui-library/element-ui.js";
import "./utils/Ui-library/vant-ui.js";

import VConsole from "vconsole";
if (process.env.VUE_APP_TITLE !== "production") {
  new VConsole();
}

// 线上比较缓存版本号刷新页面清除缓存-需要在package.json修改版本号以及app.vue里修改版本号
const VUE_APP_VERSION = require("../package.json").version;
const vers = window.localStorage.getItem("appVersion");
if (VUE_APP_VERSION != vers) {
  // localStorage.clear()
  localStorage.removeItem("appVersion");
  window.localStorage.setItem("appVersion", VUE_APP_VERSION);
  location.reload();
}

//登陆风险账号弹框全局方法
Vue.prototype.isKycLoginToast = function (vm) {
  vm.tipsState = true;
  vm.BuyTimeOut = "login";
};

import VueClipBoard from "vue-clipboard2";
Vue.use(VueClipBoard);

Vue.prototype.$api = api;
Vue.prototype.$axios = axios;
Vue.prototype.$numberHandle = numberHandle;
Vue.prototype.$mathJs = mathJs;
Vue.prototype.$bridge = bridge;

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
